var BaseBarSeries = require("./BaseBarSeries");

var _default = BaseBarSeries.extend({
  type: 'series.bar',
  dependencies: ['grid', 'polar'],
  brushSelector: 'rect'
});

module.exports = _default;


//////////////////
// WEBPACK FOOTER
// /mnt/f/projects/react-echarts3/~/echarts/lib/chart/bar/BarSeries.js
// module id = 267
// module chunks = 0